export class ScriptLoaderService {
  public loadScript(scriptUrl: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const $script = document.createElement('script');
      $script.setAttribute('src', scriptUrl);
      $script.onload = () => resolve(true);
      $script.onerror = () => reject();
      document.head.appendChild($script);
    });
  }
}
